import React, { Fragment, useEffect, useState } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { Col, Modal, Row } from "react-bootstrap";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import { coachviewprofile, coachcalendarlist } from "../../../services/coach";
import { schoolheadcalenderlist } from "../../../services/schoolhead";
import { schoollistmaster, sportslist } from "../../../services/master";
import WebUrl from "../../../AWebUrl";
import dotracking from "../../trackinglogs";
import trackobj from "../../trackingpages.json";
import { statisticslist, fundergraphlist, fundermedalslist } from "../../../services/superadmin";
import Select from "react-select";
import { Bar, Line } from "react-chartjs-2";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js/auto";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const CoachDashboard = () => {
  const navigate = useNavigate();
  const [schweb, setSchWeb] = useState("");
  const [lchartData, setLChartData] = useState(null);
  const [bchartData, setBChartData] = useState(null);
  const [mlist, setMList] = useState([]);
  const [splist, setSportList] = useState([]);
  const [tsport, setTSport] = useState(0);
  const [tyear, setTYear] = useState(0);
  const [coachid, setCoachId] = useState("");
  const currentYear = new Date().getFullYear();
  const lastYear = currentYear - 1;
  const [opts, setOpts] = useState({});

  useEffect(() => {
    coachviewprofile().then((res) => {
      if (res.status === true) {
        setCoachId(res.data.school_id);
        const tempc = new FormData();
        tempc.append("school_id", res.data.school_id);

        // Use new calendar API for UID=495357, old API for others
        const calendarAPI = localStorage.getItem("UID") == 495357
          ? coachcalendarlist({ funder_id: 0 })
          : schoolheadcalenderlist(tempc);

        calendarAPI.then((response) => {
          if (response.status === true) {
            let schedule = [];
            if (response.data.tournament_and_events.length !== 0) {
              for (
                let i = 0;
                i < response.data.tournament_and_events.length;
                i++
              ) {
                var clr = "";
                var clink = "";
                const url = window.location.href;
                const head = url.split("/#/");
                if (
                  response.data.tournament_and_events[i].type === "Tournament"
                ) {
                  clr = "#005baa";
                  clink =
                    `${head[0]}/#/coach/tournamentdetails/` +
                    response.data.tournament_and_events[i].id;
                } else if (
                  response.data.tournament_and_events[i].type ===
                    "External_1" ||
                  response.data.tournament_and_events[i].type === "External"
                ) {
                  clr = "#c21a1a";
                  clink =
                    `${head[0]}/#/coach/externaltournamentdetails/` +
                    response.data.tournament_and_events[i].id;
                } else {
                  clr = "#e59216";
                  clink =
                    `${head[0]}/#/coach/othereventdetail/` +
                    response.data.tournament_and_events[i].id;
                }
                schedule.push({
                  title: response.data.tournament_and_events[i].meet_name,
                  start: response.data.tournament_and_events[i].startdate,
                  end: response.data.tournament_and_events[i].enddate,
                  description: response.data.tournament_and_events[i].type,
                  url: clink,
                  color: clr,
                });
              }
              setEvents(schedule);
            }
          }
        });

        schoollistmaster().then((response) => {
          if (response.status === true) {
            const sdata = response.data.details.find((data) => {
              return data.id == res.data.school_id;
            });
            if (sdata !== undefined) {
              if (sdata.website_publised_status == 1) {
                setSchWeb(WebUrl + sdata.website_url);
              }
            }
          }
        });

        listsport(0, 0, res.data.school_id);

        // Load Participation Statistics graph data only for UID=495357
        if (localStorage.getItem("UID") == 495357) {
          const temp1 = new FormData();
          temp1.append("funder_id", 34);
          temp1.append("funder_or_manager", 1);

          // Load bar chart data (Male/Female by meet type) from fundermedalslist
          fundermedalslist(temp1).then((res) => {
            if (res.status === true) {
              const years = res.data.map((item) => item.meet_type);
              const maleCounts = res.data.map((item) => item.male_count);
              const femaleCounts = res.data.map((item) => item.female_count);
              const pdata = {
                labels: years,
                datasets: [
                  {
                    label: "Male",
                    data: maleCounts,
                    backgroundColor: "#25e3da",
                  },
                  {
                    label: "Female",
                    data: femaleCounts,
                    backgroundColor: "#f74dc1",
                  },
                ],
              };
              setBChartData(pdata);
            }
          });

          // Load line chart data (year-wise trends) from fundergraphlist
          fundergraphlist(temp1).then((graphRes) => {
            if (graphRes.status === true) {
              const apiData = graphRes.data;
              const years = apiData.map((item) => item.year);

              const meetTypes = apiData[0].data.map((item) => item.meet_type);

              const meetTypeColors = {
                International: "#25e3da",
                National: "#2977ff",
                State: "#f74dc1",
                Zonal: "#83efbe",
                District: "#cb83ef",
                "Inter-School": "#e8f167",
                "Intra-School": "#f1ae67",
              };

              // Line chart datasets
              const ldatasets = meetTypes.map((meetType) => {
                const data = years.map((year) => {
                  const yearData = apiData.find((item) => item.year === year);
                  const meet = yearData
                    ? yearData.data.find((m) => m.meet_type === meetType)
                    : null;
                  return meet ? meet.male_count + meet.female_count : 0;
                });

                return {
                  label: meetType,
                  data: data,
                  borderColor: meetTypeColors[meetType] || "#cccccc",
                  tension: 0.4,
                  fill: false,
                };
              });

              setLChartData({
                labels: years,
                datasets: ldatasets,
              });
            }
          });
        }
      }
    });

    sportslist().then((response) => {
      if (response.status === true) {
        if (response.data.length > 0) {
          let arr = [];
          for (let i = 0; i < response.data.length; i++) {
            arr.push({
              value: response.data[i].sports_cat_uid,
              label: response.data[i].sports_category,
            });
          }
          setSportList(arr);
        }
      }
    });
  }, []);

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState("");
  const [events, setEvents] = useState([]);

  const openModal = (event) => {
    setSelectedEvent(event);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setSelectedEvent("");
    setModalIsOpen(false);
  };

  const handleEventClick = (info) => {
    const clickedEvent = {
      title: info.event.title,
      start: info.event.startStr,
      end: info.event.endStr,
      description: info.event.description,
      sports: info.event.sports,
      event: info.event.event,
    };
    openModal(clickedEvent);
  };

  function weblink() {
    dotracking(
      "visit school webpage button in dashboard for " +
        schweb +
        " $$ " +
        trackobj.dashheading
    );
    if (schweb !== "") {
      window.open(schweb, "_blank");
    }
  }

  function handleSport(e) {
    if (e !== null) {
      setTSport(e);
      listsport(e, tyear, coachid);
    } else {
      setTSport(0);
      listsport(0, tyear, coachid);
    }
  }

  function listsport(spid, fyear, sid) {
    setMList([]);
    setTYear(fyear);
    const temp = new FormData();
    temp.append("year", fyear);
    if (spid !== 0) {
      temp.append("sports", spid.value);
    } else {
      temp.append("sports", "");
    }
    temp.append("funder_id", 34);
    temp.append("funder_or_manager", 1);

    statisticslist(temp).then((res) => {
      if (res.status === true) {
        setMList(res.data);
      }
    });

    if (window.innerWidth < 768) {
      const odata = {
        responsive: true,
        maintainAspectRatio: false,

        plugins: {
          legend: {
            position: "top",
          },
          title: {
            display: true,
            //   text: 'ABC',
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: "",
            },
          },
          y: {
            title: {
              display: true,
              text: "",
            },
          },
        },
      };
      setOpts(odata);
    } else {
      const odata = {
        responsive: true,
        maintainAspectRatio: true,

        plugins: {
          legend: {
            position: "top",
          },
          title: {
            display: true,
            //   text: 'ABC',
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: "",
            },
          },
          y: {
            title: {
              display: true,
              text: "",
            },
          },
        },
      };
      setOpts(odata);
    }
  }

  return (
    <Fragment>
      <div className="side-app">
        <div className="page-header">
          <div className="breadcrumb">
            <h4 className="mb-0">Dashboard</h4>
          </div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a>Home</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Dashboard
            </li>
          </ol>
        </div>

        <div className="row row-cards">
          <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
            <div className="card bg-custom">
              <div className="card-body text-center feature">
                <div className="fa-stack fa-lg fa-1x icons shadow-default bg-info">
                  <i className="icon-people text-white"></i>
                </div>
                <p className="card-text mt-3 mb-3">UID</p>
                <p className="h3 text-center text-info">
                  {localStorage.getItem("Name")}
                </p>
              </div>
            </div>
          </div>

          <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
            <div className="card bg-custom">
              <div className="card-body text-center feature">
                <div className="fa-stack fa-lg fa-1x icons shadow-default bg-primary">
                  <i className="icon icon-location-pin text-white"></i>
                </div>
                <p className="card-text mt-3 mb-3">Name</p>
                <p className="h3 text-center text-primary-1">
                  {localStorage.getItem("User")}
                </p>
              </div>
            </div>
          </div>

          {/* <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
            <div className="card bg-custom">
              <div className="card-body text-center feature">
                <div className="fa-stack fa-lg fa-1x icons shadow-default bg-teal">
                  <i className="fa fa-bank text-white-1 text-white"></i>
                </div>
                <p className="card-text mt-3 mb-3">Sports</p>
                <p className="h3 text-center text-teal">Football</p>
              </div>
            </div>
          </div>

          <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
            <div className="card bg-custom">
              <div className="card-body text-center feature">
                <div className="fa-stack fa-lg icons shadow-default bg-purple">
                  <i className="fa fa-soccer-ball-o text-white"></i>
                </div>
                <p className="card-text mt-3 mb-3">Achievements</p>
                <p className="h3 text-center text-purple">0</p>
              </div>
            </div>
          </div> */}
        </div>


        {/* <div className="ag-format-container">
          <div className="ag-courses_box">
            {filterProduct.length !== 0 && (
              <div className="ag_courses_head mt-4">
                <h3>Upcoming Tournaments</h3>
              </div>
            )}
            {filterProduct.map((data, i) => {
              return (
                <div className="ag-courses_item me-4" key={i}>
                  <div className="ag-courses-item_link">
                    <div className="ag-courses-item_bg"></div>
                    <div className="ag-courses-item_title pb-2 border-bottom">
                      {data.meet_name}
                    </div>

                    <div className="ag-courses-item_date-box pb-1">
                      <div className="row">
                        <div className="col-md-6">
                          Start Date :
                          <span className="ag-courses-item_date">
                            {moment(data.start_date).format("DD-MM-YYYY")}
                          </span>
                        </div>
                        <div className="col-md-6">
                          End Date :
                          <span className="ag-courses-item_date">
                            {moment(data.end_date).format("DD-MM-YYYY")}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="ag-courses-item_date-box">
                      <div className="row">
                        <div className="col-md-6">
                          Entry Open :
                          <span className="ag-courses-item_date">
                            {moment(data.entry_open).format("DD-MM-YYYY")}
                          </span>
                        </div>
                        <div className="col-md-6">
                          Entry Close :
                          <span className="ag-courses-item_date">
                            {moment(data.entry_deadline_date).format(
                              "DD-MM-YYYY"
                            )}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="ag-courses-item_date-box pt-2 mt-2 border-top">
                      {data.sports_type.toUpperCase() === "ATHLETICS" &&
                        data.meettype === "Inter School Tournament" &&
                        moment(new Date()).format("yyyy-MM-DD") <=
                          data.entry_deadline_date &&
                        data.paid_status !== 1 && (
                          <a
                            className="btn btn-sm btn-success float-left"
                            onClick={() =>
                              addlist(data.id, data.meet_name, data.paid_status)
                            }
                          >
                            Register
                          </a>
                        )}

                      {data.sports_type.toUpperCase() === "ATHLETICS" &&
                        data.meettype === "Inter School Tournament" &&
                        data.paid_status === 1 && moment(new Date()).format("yyyy-MM-DD") <=
                        data.entry_deadline_date &&(
                          <a
                            className="btn btn-sm btn-gray float-left"
                            onClick={() =>
                              addlist(data.id, data.meet_name, data.paid_status)
                            }
                          >
                            View Entries
                          </a>
                        )}

                      {data.sports_type.toUpperCase() !== "ATHLETICS" &&
                        data.meettype === "Inter School Tournament" &&
                        data.paid_status !== 1 &&
                        moment(new Date()).format("yyyy-MM-DD") <=
                          data.entry_deadline_date && (
                          <a
                            className="btn btn-sm btn-success float-left"
                            onClick={() =>
                              addsportlist(
                                data.id,
                                data.meet_name,
                                data.paid_status
                              )
                            }
                          >
                            Register
                          </a>
                        )}
                      {data.sports_type.toUpperCase() !== "ATHLETICS" &&
                        data.meettype === "Inter School Tournament" &&
                        data.paid_status === 1 &&
                        moment(new Date()).format("yyyy-MM-DD") <=
                          data.entry_deadline_date && (
                          <a
                            className="btn btn-sm btn-success float-left"
                            onClick={() =>
                              addsportlist(
                                data.id,
                                data.meet_name,
                                data.paid_status
                              )
                            }
                          >
                            Add Teams
                          </a>
                        )}
                      {moment(new Date()).format("yyyy-MM-DD") >
                        data.entry_deadline_date && (
                        <span className="errortext float-left tx-18">
                          Entry Closed
                        </span>
                      )}

                      <a
                        className="btn btn-sm btn-secondary float-right viewbtndash"
                        onClick={() => viewlist(data.id, data.meet_name)}
                      >
                        View Tournament
                      </a>
                    </div>
                  </div>
                </div>
              );
            })}

            {cfilterProduct.length !== 0 && (
              <div className="ag_courses_head mt-4">
                <h3>Completed Tournaments</h3>
              </div>
            )}
            {cfilterProduct.map((data, i) => {
              return (
                <div className="ag-courses_item me-4" key={i}>
                  <div className="ag-courses-item_link">
                    <div className="ag-courses-item_bg"></div>
                    <div className="ag-courses-item_title pb-2 border-bottom">
                      {data.meet_name}
                    </div>

                    <div className="ag-courses-item_date-box pb-1">
                      {data.meet_tour_type === "Internal" && (
                        <div className="row">
                          <div className="col-md-6">
                            Start Date :
                            <span className="ag-courses-item_date">
                              {moment(data.start_date).format("DD-MM-YYYY")}
                            </span>
                          </div>
                          <div className="col-md-6">
                            End Date :
                            <span className="ag-courses-item_date">
                              {moment(data.end_date).format("DD-MM-YYYY")}
                            </span>
                          </div>
                        </div>
                      )}
                      {data.meet_tour_type === "External" && (
                        <div className="row">
                          <div className="col-md-6">
                            Start Date :
                            <span className="ag-courses-item_date">
                              {data.startdate}
                            </span>
                          </div>
                          <div className="col-md-6">
                            End Date :
                            <span className="ag-courses-item_date">
                              {data.enddate}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="ag-courses-item_date-box">
                      {data.meet_tour_type === "Internal" && (
                        <div className="row">
                          <div className="col-md-6">
                            Entry Open :
                            <span className="ag-courses-item_date">
                              {moment(data.entry_open).format("DD-MM-YYYY")}
                            </span>
                          </div>
                          <div className="col-md-6">
                            Entry Close :
                            <span className="ag-courses-item_date">
                              {moment(data.entry_deadline_date).format(
                                "DD-MM-YYYY"
                              )}
                            </span>
                          </div>
                        </div>
                      )}
                      {data.meet_tour_type === "External" && (
                        <div className="row">
                          <div className="col-md-6">
                            Sports :
                            <span className="ag-courses-item_date">
                              {data.sports_type}
                            </span>
                          </div>
                          <div className="col-md-6">
                            <span className="errortext tx-20">
                              {data.meet_tour_type}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="ag-courses-item_date-box pt-2 mt-2 border-top">
                      <a
                        className="btn btn-sm btn-secondary float-right viewbtndash"
                        onClick={() =>
                          compviewlist(
                            data.id,
                            data.meet_name,
                            data.meet_tour_type
                          )
                        }
                      >
                        View Tournament
                      </a>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="ag-format-container">
          <div className="ag-courses_box">
            {eventProduct.length !== 0 && (
              <div className="ag_courses_head mt-4">
                <h3>Upcoming Events</h3>
              </div>
            )}
            {eventProduct.map((data, i) => {
              return (
                <div className="ag-courses_item me-4" key={i}>
                  <div className="ag-courses-item_link">
                    <div className="ag-courses-item_bg"></div>
                    <div className="ag-courses-item_title pb-2 border-bottom">
                      {data.event_name}
                    </div>

                    <div className="ag-courses-item_date-box pb-1">
                      <div className="row">
                        <div className="col-md-6">
                          Start Date :
                          <span className="ag-courses-item_date">
                            {moment(data.start_date).format("DD-MM-YYYY")}
                          </span>
                        </div>
                        <div className="col-md-6">
                          End Date :
                          <span className="ag-courses-item_date">
                            {moment(data.end_date).format("DD-MM-YYYY")}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="ag-courses-item_date-box">
                      <div className="row">
                        <div className="col-md-6">
                          Entry Open :
                          <span className="ag-courses-item_date">
                            {moment(data.entry_start_date).format("DD-MM-YYYY")}
                          </span>
                        </div>
                        <div className="col-md-6">
                          Entry Close :
                          <span className="ag-courses-item_date">
                            {moment(data.entry_end_date).format("DD-MM-YYYY")}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="ag-courses-item_date-box pt-2 mt-2 border-top">
                      <a
                        className="btn btn-sm btn-secondary float-right viewbtndash"
                        onClick={() => vieweventlist(data.id, data.event_name)}
                      >
                        View Event
                      </a>
                    </div>
                  </div>
                </div>
              );
            })}

            {ceventProduct.length !== 0 && (
              <div className="ag_courses_head mt-4">
                <h3>Completed Events</h3>
              </div>
            )}
            {ceventProduct.map((data, i) => {
              return (
                <div className="ag-courses_item me-4" key={i}>
                  <div className="ag-courses-item_link">
                    <div className="ag-courses-item_bg"></div>
                    <div className="ag-courses-item_title pb-2 border-bottom">
                      {data.event_name}
                    </div>

                    <div className="ag-courses-item_date-box pb-1">
                      <div className="row">
                        <div className="col-md-6">
                          Start Date :
                          <span className="ag-courses-item_date">
                            {moment(data.start_date).format("DD-MM-YYYY")}
                          </span>
                        </div>
                        <div className="col-md-6">
                          End Date :
                          <span className="ag-courses-item_date">
                            {moment(data.end_date).format("DD-MM-YYYY")}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="ag-courses-item_date-box">
                      <div className="row">
                        <div className="col-md-6">
                          Entry Open :
                          <span className="ag-courses-item_date">
                            {moment(data.entry_start_date).format("DD-MM-YYYY")}
                          </span>
                        </div>
                        <div className="col-md-6">
                          Entry Close :
                          <span className="ag-courses-item_date">
                            {moment(data.entry_end_date).format("DD-MM-YYYY")}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="ag-courses-item_date-box pt-2 mt-2 border-top">
                      <a
                        className="btn btn-sm btn-secondary float-right viewbtndash"
                        onClick={() => vieweventlist(data.id, data.event_name)}
                      >
                        View Event
                      </a>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>*/}

        {/* {schweb !== "" && (
          <div className="text-center">
            <a onClick={weblink} className="btnfixture">
              Visit School Webpage
            </a>
          </div>
        )} */}

        {localStorage.getItem("UID") == 495357 && (
          <>
            <div className="ag_courses_head">
              <h4>Players Statistics</h4>
            </div>
            <div className="row">
              <div className="col-md-4">
                <label className="form-label">Sports</label>
                <Select
                  className="dropdown"
                  placeholder="Select Sports"
                  value={tsport}
                  options={splist}
                  onChange={handleSport}
                  isSearchable={true}
                  isClearable
                  hidden
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Financial Year</label>

                <select
                  className="form-control"
                  value={tyear}
                  onChange={(e) => listsport(tsport, e.target.value, coachid)}
                >
                  <option value={0}>All</option>
                  <option value={currentYear}>Current Year</option>
                  <option value={lastYear}>Last Year</option>
                </select>
              </div>
            </div>
            <div className="row">
              <div className="col-md-5">
                <div className="table-responsive">
                  <table className="sp-league-table sp-data-table">
                    <thead className="sp-table-header">
                      <tr role="row">
                        <th className="text-center">Players</th>
                        <th className="text-center">Male</th>
                        <th className="text-center">Female</th>
                        <th className="text-center">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {mlist.map((item, j) => {
                        const getRowColor = () => {
                          return j % 2 === 0 ? "even" : "odd";
                        };
                        return (
                          <>
                            <tr
                              className={`sp-row-no-0 ${getRowColor()}`}
                              role="row"
                              key={j}
                              style={{ cursor: "pointer" }}
                            >
                              <td className="data-pct">{item.meet_type}</td>
                              <td className="data-pct">{item.male_count}</td>
                              <td className="data-pct">{item.female_count}</td>
                              <td className="data-pct">
                                {item.male_count + item.female_count}
                              </td>
                            </tr>
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="col-md-7">
                <div className="table-responsive">
                  <table className="sp-league-table sp-data-table">
                    <thead className="sp-table-header">
                      <tr role="row">
                        <th className="text-center">Players</th>
                        <th className="text-center">&lt;8 Years</th>
                        <th className="text-center">8-14 Years</th>
                        <th className="text-center">15-18 Years</th>
                        <th className="text-center">&gt;18 Years</th>
                        <th className="text-center">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {mlist.map((item, j) => {
                        const getRowColor = () => {
                          return j % 2 === 0 ? "even" : "odd";
                        };
                        return (
                          <>
                            <tr
                              className={`sp-row-no-0 ${getRowColor()}`}
                              role="row"
                              key={j}
                              style={{ cursor: "pointer" }}
                            >
                              <td className="data-pct">{item.meet_type}</td>
                              <td className="data-pct">
                                {item.female_age_8 + item.male_age_8}
                              </td>
                              <td className="data-pct">
                                {item.female_age_8_14 + item.male_age_8_14}
                              </td>
                              <td className="data-pct">
                                {item.female_age_15_18 + item.male_age_15_18}
                              </td>
                              <td className="data-pct">
                                {item.female_age_18_plus + item.male_age_18_plus}
                              </td>

                              <td className="data-pct">
                                {item.female_age_8 +
                                  item.male_age_8 +
                                  item.female_age_8_14 +
                                  item.male_age_8_14 +
                                  item.female_age_15_18 +
                                  item.male_age_15_18 +
                                  item.female_age_18_plus +
                                  item.male_age_18_plus}
                              </td>
                            </tr>
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="ag_courses_head mt-2">
              <h4>Participation Statistics</h4>
            </div>
            <div className="col-md-12">
              <div id="chart-container">
                {bchartData && bchartData.labels && bchartData.datasets && (
                  <Bar data={bchartData} options={opts} />
                )}
              </div>

              <div id="chart-container">
                {lchartData && lchartData.labels && lchartData.datasets && (
                  <Line data={lchartData} options={opts} />
                )}
              </div>
            </div>

            <hr />
          </>
        )}

        <div className="row">
          <div className="ag_courses_head">
            <h4>Tournament & Events Calender</h4>
          </div>
          <div className="col-12">
            <div className="card mt-0">
              <div className="card-body">
                <FullCalendar
                  plugins={[dayGridPlugin]}
                  initialView="dayGridMonth"
                  events={events}
                  eventClick={handleEventClick}
                />

                <Modal show={modalIsOpen} size="xl">
                  <Modal.Header>
                    <Modal.Title>Tournament & Events Details</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="table-responsive">
                      <table className="sp-league-table sp-data-table">
                        <thead className="sp-table-header">
                          <tr role="row">
                            <th className="text-center">Title</th>
                            <th className="text-center">Start Date</th>
                            <th className="text-center">End Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="sp-row-no-0 even" role="row">
                            <td class="data-pct">{selectedEvent.title}</td>
                            <td class="data-pct">
                              {moment(selectedEvent.start).format("DD-MM-YYYY")}
                            </td>
                            {selectedEvent.end !== "" && (
                              <td className="data-pct">
                                {moment(selectedEvent.end).format("DD-MM-YYYY")}
                              </td>
                            )}
                            {selectedEvent.end === "" && (
                              <td className="data-pct">
                                {moment(selectedEvent.start).format(
                                  "DD-MM-YYYY"
                                )}
                              </td>
                            )}
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <a className="btn btn-gray" onClick={closeModal}>
                      Close
                    </a>
                  </Modal.Footer>
                </Modal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
